import { render, staticRenderFns } from "./MedicalOffices.vue?vue&type=template&id=b1190aa8"
import script from "./MedicalOffices.vue?vue&type=script&lang=js"
export * from "./MedicalOffices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports